import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from 'components'
import ModalWindow from 'hooks/ModalWindow/ModalWindow'
import { AnswerToInvite } from 'service/CollectiveService'
import Notification from 'utils/Notifications'
import userInfo from 'utils/userInfo'
import styles from './AlertCardMain.module.scss'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Badge from '@mui/material/Badge'
import Typography from '@mui/material/Typography'
import { setAlertById } from 'store/slices/AlertSlice'
import moment from 'moment';


function useScrollTop() {
  const [scrollTop, setScrollTop] = useState(0)
  const onScroll = (event) => setScrollTop(event.target.scrollTop)
  return [scrollTop, { onScroll }]
}

const AlertPopOver = () => {
  const { t } = useTranslation('common')
  const [scrollTop, scrollProps] = useScrollTop()
  const [data, setData] = useState([])
  const user = userInfo()
  const [openModal, setOpenModal] = useState({
    modalActive: false,
    inviterName: '',
    command: '',
  })
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const dispatch = useDispatch()
  const navigate = useNavigate()
 
  const alert = useSelector((state) => state.alert.alerts)
  const messages = useSelector((state) => state.alert.alertsMessages)

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [width])
  useEffect(() => {
    width < 600 && handleSideNavToggle()
  })
  function handleSideNavToggle() {}

  const [stateUserInfo, setStateUserInfo] = useState({
    idUser: '',
    isPaneOpen: false,
    isPaneOpenLeft: false,
  })

  const openLink = (item) => {
    if (!item) {
      return
    }
    const parts = item.ssylca.split('/');
    const nav = parts[0];
    const navid = parts[1];
    const socket = new WebSocket(
      `wss://sys.chu.kg/ws/notifications/${user.userId}/`,
    )
    if (item.ssylca && item.ssylca.includes('task')) {
      socket.onopen = () => {
        socket.send(
          JSON.stringify({ command: 'read_notification', id: item.id }),
        )
        socket.close()
      }
      navigate(`/${nav}/`, { state: { usedId: navid } });
    } else {
      socket.onopen = () => {
        socket.send(
          JSON.stringify({ command: 'read_notification', id: item.id }),
        )
        socket.close()
      }
      navigate(`/${nav}/`, { state: { usedId: navid } });
    }
  }
  const openMessage = (item) => {
    navigate('/chats/')
  }
  const openLinkById = (userId) => {
    const parts = userId.split('/');
    const nav = parts[0];
    const navid = parts[1];
    return navid;
  }
  const handleAccept = async (item, id_alert) => {
    const numbers = item.match(/\d+/)
    
   
    let extractedNumber = null
    if (numbers !== null) {
      extractedNumber = parseInt(numbers[0]) 
    }

    const command_id = extractedNumber

    try {
      let response = await AnswerToInvite(command_id, {
        members: [{ user_id: user.userId, is_confirmed: true }],
      })
       
    
     
      setNotify({
        isOpen: true,
        message: t('main.added_to_team'),
        type: 'success',
        sound: 'success',
      })
      const socket = new WebSocket(
        `wss://sys.chu.kg/ws/notifications/${user.userId}/`,
      )
      socket.onopen = () => {
        socket.send(
          JSON.stringify({ command: 'read_notification', id: id_alert }),
        )
        socket.close()
      }
      const filteredAlerts = alert.filter(
        (alertItem) => alertItem.id !== id_alert,
      )
   
      dispatch(
        setAlertById({
          alerts: filteredAlerts,
        }),
      )

      // Wave Final (P1-F14): navigate('/home/') достаточно — store обновлён.
      navigate('/home/')
    } catch (error) {

      setNotify({
        isOpen: true,
        message: t('common.error'),
        type: 'error',
        sound: 'error',
      })
    }
  }

  const handleDecline = async (item, id_alert) => {
    const numbers = item.match(/\d+/)

    let extractedNumber = null
    if (numbers !== null) {
      extractedNumber = parseInt(numbers[0]) 
    }

    const command_id = extractedNumber
    try {
      let response = await AnswerToInvite(command_id, {
        members: [{ user_id: user.userId, is_confirmed: false }],
      })

      setNotify({
        isOpen: true,
        message: t('main.declined'),
        type: 'success',
        sound: 'success',
      })
      const socket = new WebSocket(
        `wss://sys.chu.kg/ws/notifications/${user.userId}/`,
      )

      socket.onopen = () => {
        socket.send(
          JSON.stringify({ command: 'read_notification', id: id_alert }),
        )
        socket.close()
      }
      const filteredAlerts = alert.filter(
        (alertItem) => alertItem.id !== id_alert,
      )

      dispatch(
        setAlertById({
          alerts: filteredAlerts,
        }),
      )
      setOpenModal({ modalActive: false })
    } catch (error) {

      setNotify({
        isOpen: true,
        message: t('common.error'),
        type: 'error',
        sound: 'error',
      })
    }
  }

  const [expanded, setExpanded] = useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  const formatDate = (dateString) => { 
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();
  
    if (date.isSame(today, 'day')) {
      return date.format(`[${t('weather.today_word')}] HH:mm`);
     }
    else if(date.isSame(today, 'year')){
      return date.format('DD MMMM HH:mm')
     } 
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
};
  return (
    <div
      className={styles.news_card_wrapper}
      {...scrollProps}
      style={{
        boxShadow: scrollTop > 0 ? 'none' : 'none',
        maxHeight: width < 900 ? 'unset' : '750px',
        overflow: 'auto',
      }}
    >
      <div className={styles.alert_format}>
        
          
          <Typography>
                {[...alert]?.reverse().length === 0 ? (
                  <div className={styles.news_card}>
                    <div className={styles.news_heading}>
                      <div className={styles.user_info}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              paddingTop: '5px',
                            }}
                          >
                            <h4 className={styles.user_login}>
                              {t('main.no_alerts')}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  [...alert]?.slice(0, 3)?.map((item) => {
                    return (
                      <div className={styles.news_card}>
                        <div className={styles.news_heading}>
                          <div
                            className={styles.user_info}
                            onClick={() => {
                              if (item.status === 'U') {
                                openMessage(item)
                              } else if (
                                item?.ssylca?.includes('teams') ||
                                item?.ssylca?.includes('command')
                              ) {
                                setOpenModal({
                                  modalActive: true,
                                  inviterName: item.surname_name,
                                  message: item.alerts,
                                  id_alert: item.id,
                                  command: item.ssylca,
                                })
                              } else {
                                openLink(item)
                              }
                            }}
                          >
                            <div style={{ display: 'flex', gap: '10px' }}>
                             
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  paddingTop: '5px',
                                }}
                              >
                                
                                <h4 className={styles.body_title}>
                                {formatDate(item.date_alerts)} - {item.alerts} 
                                </h4>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      </div>
                    )
                  })
                )}
              </Typography>
        
      </div>
      
      <ModalWindow
        setOpenModal={setOpenModal}
        openModal={openModal.modalActive}
        modalTitle={`${openModal.inviterName}`}
        modalText={`${openModal?.message}`}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              onClick={() =>
                handleDecline(openLinkById(openModal.command), openModal.id_alert)
              }
              className={styles.btn_pin_close}
            >
              {t('common.decline')}
            </Button>
            <Button
              onClick={() =>
                handleAccept(openLinkById(openModal.command), openModal.id_alert)
              }
              className={styles.btn_pin}
            >
              {t('common.accept')}
            </Button>
          </div>
        </div>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default AlertPopOver
